import { http } from "../client";
import { mapUserObjectToUser } from "../shared/user";
var isRegisterFailure = function (error) { var _a, _b; return (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors; };
export var register = function (_a) {
    var login = _a.login, password = _a.password, role = _a.role, lang = _a.lang;
    var data = {
        email: login,
        password: password,
        password_confirmation: password,
        role: role,
        lang: lang,
    };
    return http.base
        .post("/register", data)
        .then(function (response) {
        return ({
            type: "success",
            payload: mapUserObjectToUser(response.data),
        });
    })
        .catch(function (error) {
        if (!isRegisterFailure(error)) {
            throw Error();
        }
        return {
            type: "fail",
            payload: error.response.data.errors,
        };
    });
};
